import { queryOptions } from '@tanstack/react-query';
import type {
  NewsResponseDto,
  HomeHeroResponseDto,
  HomeBannersResponseDto,
  TopSearchResponseDto,
} from '@marxbiotech/shared-types/cms';

import { api } from '@lib/api/client';

// Re-export types for backwards compatibility
export type { NewsItemDto as NewsItem, NewsResponseDto as NewsResponse } from '@marxbiotech/shared-types/cms';

async function fetchNews(): Promise<NewsResponseDto> {
  const response = await api.get<NewsResponseDto>('/cms/news');
  return response.data;
}

export const newsQueryOptions = queryOptions({
  queryKey: ['cms', 'news'],
  queryFn: fetchNews,
});

async function fetchHomeHero(): Promise<HomeHeroResponseDto> {
  const response = await api.get<HomeHeroResponseDto>('/cms/home/hero');
  return response.data;
}

export const homeHeroQueryOptions = queryOptions({
  queryKey: ['cms', 'home', 'hero'],
  queryFn: fetchHomeHero,
  staleTime: 5 * 60 * 1000, // 5 minutes - CMS content doesn't need real-time updates
});

async function fetchHomeBanners(): Promise<HomeBannersResponseDto> {
  const response = await api.get<HomeBannersResponseDto>('/cms/home/banners');
  return response.data;
}

export const homeBannersQueryOptions = queryOptions({
  queryKey: ['cms', 'home', 'banners'],
  queryFn: fetchHomeBanners,
  staleTime: 5 * 60 * 1000, // 5 minutes - CMS content doesn't need real-time updates
});

async function fetchTopSearch(): Promise<TopSearchResponseDto> {
  const response = await api.get<TopSearchResponseDto>('/cms/top-search');
  return response.data;
}

export const topSearchQueryOptions = queryOptions({
  queryKey: ['cms', 'top-search'],
  queryFn: fetchTopSearch,
  staleTime: 5 * 60 * 1000, // 5 minutes - CMS content doesn't need real-time updates
});
